var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fullcontainer centerbg",staticStyle:{"background-image":"url('res/p3/ccyjsbg.jpg')"}},[_c(_vm.currentView,{ref:"component",tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }